import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Landing.css'

export default function Landing() {
  const navigate = useNavigate()

  return (
    <div className="landing">
      <nav className="landing-nav">
        <div className="landing-logo">STOP <span>PACANELE</span></div>
        <div className="landing-nav-links">
          <a href="#cum-functioneaza">Cum functioneaza</a>
          <a href="#educatie">Educatie</a>
          <a href="#pret">Pret</a>
          <button className="btn-primary" onClick={() => navigate('/register')}>Incepe gratuit</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="lp-hero">
        <div className="hero-pill">
          <span className="hero-pill-dot" />
          Program de recuperare · 90 de zile
        </div>
        <h1>Scapa de pacănele.<br /><em>Zi dupa zi.</em></h1>
        <p className="hero-sub">
          Un program structurat care combina tracking zilnic, psihologie comportamentala
          si un simulator terapeutic unic — ca sa vezi cu ochii tai cum functioneaza dependenta.
        </p>
        <div className="hero-actions">
          <button className="btn-primary btn-lg" onClick={() => navigate('/register')}>
            Incepe programul gratuit
          </button>
          <button className="btn-ghost btn-lg" onClick={() => navigate('/educatie')}>
            Cum functioneaza?
          </button>
        </div>
        <div className="trust-row">
          <span>✓ Calendar, jurnal & educatie gratuit</span>
          <span>✓ Simulator: 34,99 lei/luna</span>
          <span>✓ Anonim 100%</span>
          <span>✓ Anulezi oricand</span>
        </div>
      </section>

      {/* STATS BAND */}
      <div className="stats-band">
        <div className="stat-item"><div className="stat-num">2,840+</div><div className="stat-lbl">utilizatori activi</div></div>
        <div className="stat-item"><div className="stat-num">68 zile</div><div className="stat-lbl">streak mediu</div></div>
        <div className="stat-item"><div className="stat-num">1,200 lei</div><div className="stat-lbl">economisiti in medie</div></div>
        <div className="stat-item"><div className="stat-num">94%</div><div className="stat-lbl">continua dupa ziua 30</div></div>
      </div>

      {/* CUM FUNCTIONEAZA */}
      <section className="lp-section" id="cum-functioneaza">
        <div className="section-eyebrow">Cum functioneaza</div>
        <h2 className="section-title">3 pasi spre libertate</h2>
        <div className="steps-grid">
          <div className="step-card">
            <div className="step-num">01</div>
            <h3>Iti faci profilul</h3>
            <p>Raspunzi onest la 10 intrebari despre situatia ta. AI-ul calculeaza bugetul tau real si gravitatea dependentei.</p>
          </div>
          <div className="step-card">
            <div className="step-num">02</div>
            <h3>Simulezi realitatea</h3>
            <p>Folosesti simulatorul nostru de slot cu banii tai reali — si vezi exact ce pierzi din mancare, utilitati, rata, copii.</p>
          </div>
          <div className="step-card">
            <div className="step-num">03</div>
            <h3>Bifezi fiecare zi</h3>
            <p>Calendar zilnic, streak de zile libere, jurnal personal si badge-uri. Progresul vizibil te tine motivat.</p>
          </div>
        </div>
      </section>

      {/* SLOT PREVIEW */}
      <section className="lp-section lp-slot-preview">
        <div className="slot-preview-content">
          <div className="section-eyebrow">Simulatorul terapeutic</div>
          <h2 className="section-title">Te lasam sa joci.<br />Cu banii tai reali.</h2>
          <p className="section-sub">
            Nu iti spunem sa nu joci. Iti aratam exact ce se intampla cand joci —
            in timp real, cu sumele tale, cu facturile tale, cu familia ta.
          </p>
          <ul className="slot-preview-features">
            <li>🔴 Fiecare pierdere scade din bugetul de mancare, rata, copii</li>
            <li>🟡 Castigurile sunt mereu mai mici decat miza — casa castiga mereu</li>
            <li>🔵 Datoriile simulate reproduce exact ce se intampla in realitate</li>
            <li>📊 La final vezi totalul pierdut si ce puteai face cu banii</li>
          </ul>
          <button className="btn-primary btn-lg" onClick={() => navigate('/register')}>
            Incearca simulatorul
          </button>
        </div>
        <div className="slot-preview-visual">
          <div className="mini-phone">
            <div className="mini-phone-top">
              <span className="mini-brand">STOP PACANELE</span>
              <span className="mini-buget">Buget: 45 lei</span>
            </div>
            <div className="mini-reels">
              <div className="mini-reel">🍒</div>
              <div className="mini-reel">🍒</div>
              <div className="mini-reel lose-reel">🎰</div>
            </div>
            <div className="mini-msg lose-msg">
              Ai pierdut 2 lei din banii de mancare
            </div>
            <div className="mini-budgets">
              <div className="mini-budget-item">
                <span>Mancare</span>
                <div className="mini-bar"><div className="mini-bar-fill" style={{width:'60%', background:'var(--red)'}} /></div>
              </div>
              <div className="mini-budget-item">
                <span>Utilitati</span>
                <div className="mini-bar"><div className="mini-bar-fill" style={{width:'75%', background:'var(--amber)'}} /></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section className="lp-section lp-pricing" id="pret">
        <div className="section-eyebrow">Pret</div>
        <h2 className="section-title">Restul e gratuit.<br />Simulatorul, abonament lunar.</h2>
        <div className="pricing-card">
          <div className="pricing-badge">Oferta de lansare</div>
          <div className="price-display"><span className="price-currency">lei</span>34,99</div>
          <div className="price-desc">pe luna · anuleaza oricand</div>
          <ul className="pricing-features">
            <li>✓ Simulator slot terapeutic personalizat</li>
            <li>✓ Calendar + tracker zile libere (gratuit)</li>
            <li>✓ Jurnal personal zilnic (gratuit)</li>
            <li>✓ Educatie despre pacanele (gratuit)</li>
            <li>✓ Profil AI personalizat</li>
            <li>✓ Anulezi oricand din profil</li>
          </ul>
          <button className="btn-primary btn-lg btn-full" onClick={() => navigate('/register')}>
            Incepe acum
          </button>
          <p className="pricing-note">Calendarul, jurnalul si educatia sunt gratuite. Doar simulatorul necesita abonament.</p>
        </div>
      </section>

      {/* FOOTER CTA */}
      <div className="footer-cta">
        <h2>Ziua 1 incepe azi.</h2>
        <p>Fiecare zi fara pacănele inseamna bani in buzunarul tau si liniste in minte.</p>
        <button className="btn-white btn-lg" onClick={() => navigate('/register')}>
          Incepe programul gratuit
        </button>
      </div>

      <footer className="landing-footer">
        <p>© 2026 STOP PACANELE · contact@stoppacanele.ro</p>
      </footer>
    </div>
  )
}
